import { sessionStorage } from '../assets/js/storage'
import dsBridge from '@/api/dsbridge.js'
let userInfo=null;
 // if(dsBridge.dsHas('getDeviceType')){
	//  userInfo = dsBridge.dsCall('getUserInfo', '');
	//  userInfo = JSON.parse(userInfo);

 // }else{
	//  userInfo = sessionStorage.getItem('user');
 // }

// const state = {
//   user: userInfo || sessionStorage.getItem('user') ||  null,
//   token: (userInfo && userInfo.token) || sessionStorage.getItem('token') ||  null,
//   mobilePhone: (userInfo &&  userInfo.phoneNum) || sessionStorage.getItem('mobilePhone') ||  null,
//   userId:(userInfo &&  userInfo.userId) || sessionStorage.getItem('userId') ||   null,
//   inviteCode: sessionStorage.getItem('inviteCode') || null,
// }
const state = {
  user:null,
  token:null,
  mobilePhone:null,
  userId:null,
  inviteCode:null
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js